import { useEffect } from 'react';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddProduct from './components/AddProduct';
import '../../styles/products.scss';

const ProductCreate = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Créer un Produit');
  }, [setTitle]);

  return (
    <div className="product-create-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddProduct />
        </Col>
      </Row>
    </div>
  );
};

export default ProductCreate;
